import { SystemError } from '#/shared/exceptions/system-error';

export const dateHeaderToTimestamp = (headers: Record<string, string | undefined>, providerName: string): number => {
  const serverDatetime = headers.date;

  if (!serverDatetime) {
    throw new SystemError('Missing server datetime from data provider service.', {
      tags: { provider: providerName },
      headers,
    });
  }

  const timestamp = new Date(serverDatetime).getTime();

  if (Number.isNaN(timestamp)) {
    throw new SystemError('Server datetime from data provider service is not a valid date.', {
      tags: { provider: providerName },
      serverDatetime,
    });
  }

  return timestamp;
};
